"use client"

import { Croissant } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CroissantIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CroissantIcon = component(Icon)({ as: Croissant })
